import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import { LocalizationProvider, LicenseInfo } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import "./dateRangePicker.css";

LicenseInfo.setLicenseKey(
  "b3797b650a3bd36f98c3dc7a00e5f266Tz00OTk4NyxFPTE2OTM0NzQ3NDQ4NzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);

const DatePicker = forwardRef(({ value, onChange }) => {
  const theme = useTheme();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        // inputFormat="YYYY-MM-DD"
        value={value}
        onChange={onChange}
        renderInput={(startProps, endProps) => (
          <React.Fragment>
            <TextField
              {...startProps}
              label=""
              size="small"
              autoComplete={"off"}
              sx={{
                ".MuiOutlinedInput-root": {
                  outline: `1px ${theme.palette.borderColor.textField}`,
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: "5px",
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
            />
            <Box sx={{ mx: 0.5 }}> to </Box>
            <TextField
              {...endProps}
              label=""
              size="small"
              autoComplete={"off"}
              sx={{
                ".MuiOutlinedInput-root": {
                  outline: `1px ${theme.palette.borderColor.textField}`,
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: "5px",
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
            />
          </React.Fragment>
        )}
      />
    </LocalizationProvider>
  );
});

export default DatePicker;
